import { TabGroup as Group } from './Tab.Group';
import { TabOption as Option } from './Tab.Option';
import { TabSetting as Setting } from './Tab.Setting';
export var Tab = {
  Group: Group,
  Option: Option,
  Setting: Setting
};